import React, { FC } from 'react'
import { Spinner } from '@mch-group/uikit-components'

interface ILoader {
  label?: string
}

const Loader: FC<ILoader> = ({ label }) => (
  <div
    style={{
      width: '100%',
      height: '75vh'
    }}
    className='d-flex align-items-center justify-content-center'
  >
    <Spinner variant='page' theme='light' label={label || 'Please wait...'} />
  </div>
)

export default Loader
